export const CustomChatNames = {
  ANNOUNCEMENTS: 'announcements',
  ALOGIX: 'alogix'
} as const
